import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Table } from './table.js';
/** The actions column's header cell — right-aligned, as every list page wrote it inline. */
export function TableActionsHeaderCell({ label, column }) {
    return (_jsx(Table.HeaderCell, { className: "text-right", column: column, children: label }));
}
TableActionsHeaderCell.displayName = 'TableActionsHeaderCell';
/** The actions column's body cell — the one place its alignment is decided. */
export function TableActionsCell({ children, column, }) {
    return (_jsx(Table.Cell, { className: "text-right", column: column, children: children }));
}
TableActionsCell.displayName = 'TableActionsCell';
function headerCellKey(cell, index) {
    return React.isValidElement(cell) && cell.key !== null ? `k:${cell.key}` : `i:${index}`;
}
/**
 * Assemble a `<Table.Header>` from a base column list plus the optional actions
 * column. Shared by the loading skeleton and the loaded table so both spell out
 * the same columns from the same array.
 */
export function renderTableHeader(headerCells, actionsColumn) {
    return (_jsx(Table.Header, { children: _jsxs(Table.Row, { children: [headerCells.map((cell, i) => (_jsx(React.Fragment, { children: cell }, headerCellKey(cell, i)))), actionsColumn ? (_jsx(TableActionsHeaderCell, { label: actionsColumn.label, column: actionsColumn.column })) : null] }) }));
}
//# sourceMappingURL=table-actions-column.js.map